<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :renderColumnValue="renderColumnValue"
                :renderColumnAction="renderColumnAction"
                :rowButtonAction="rowButtonAction"
                :buttonsVisibility="buttonsVisibility">

            <template #crud="formProps">
                <OrgunitForm :formProps="formProps"> </OrgunitForm>
            </template>
            <template #search="searchProps">
                <OrgunitSearch :searchProps="searchProps"> </OrgunitSearch>
            </template>
            <template #buttons="formProps">
                <div style="margin-top:-20px">
                    <div style="font-size:14px;margin-left:7px;color:#1A83AD;font-weight:normal;">{{ __('Manager') }}:</div>
                    <div>
                        <FormDropdown fieldName="manager_id_to_filter_orgunit"
                                      label=""
                                      showClear
                                      style="width:350px;padding-top:0"
                                      :isFormDisabled="false"
                                      :change="(e) => filterWorkersByManager(e, formProps)"
                                      :options="isAdmin ? select?.managers : select?.managers_below_me"
                                      v-model:field="localManagerIdToFilterOrgunit" />
                    </div>

                </div>

            </template>
        </v-view>
    </div>
</template>

<script setup>
import { ref, watch, onBeforeMount } from "vue";
import { rowButtonAction, prepareSelect } from "@pages/Helper/crud_utils.js";
import OrgunitForm from "./OrgunitForm.vue";
import OrgunitSearch from "./OrgunitSearch.vue";
import FormDropdown from "@crud/FormDropdown.vue";
import { __, getFromRoute, getStoreValue } from '@pages/Helper/utils.js'

const props = defineProps({
    data: Object,
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    tooltipColumns: Object,
    initialSort: Object,
    buttonsVisibility: Object,
    managerIdToFilterOrgunit: Number,
});

const isAdmin = ref(getStoreValue('isAdmin'))
let options = []
const select = ref(null)
const localManagerIdToFilterOrgunit = ref(props.managerIdToFilterOrgunit)

//------------------------------------------------------------------------------

watch(() => props.managerIdToFilterOrgunit, (newValue) => {
    localManagerIdToFilterOrgunit.value = newValue;
});

//------------------------------------------------------------------------------

onBeforeMount(async () => {
    if (isAdmin.value) {
        options = ['managers']
    } else {
        options = ['managers_below_me']
    }
    select.value = await prepareSelect(options)
})

//------------------------------------------------------------------------------

const renderColumnValue = (field, value, data) => {
    switch (field) {
        case "is_premium":
            return value == 1 ? '<span class="flex justify-content-center"><i class="fa-solid fa-coins" style="font-size:20px;color:royalblue;"></i></span>' : "";
        case "is_working":
            //return value == 1 ? '<span class="flex justify-content-center"><i class="fa-solid fa-person-digging" style="font-size:20px;color:maroon;"></i></span>' : "";
            return value == 1 ? __('Yes') : __('No');
        default:
            return data.is_master_subordinate ? '<span style="color:blue">' + value + '</span>' : value;
    }
};

//------------------------------------------------------------------------------

const renderColumnAction = (item, rowData, column) => {
    let newItem = {}

    if (!rowData.is_premium) {
        newItem.tooltip = __('Not subject to premium system')
        newItem.prohibited = true
        newItem.name = '<i class="fa-solid fa-ban" style="color:black;"></i>'
    } else {
        newItem.prohibited = false
        newItem.tootip = item.tooltip
        newItem.name = item.name
    }

    return { ...newItem }
}

//------------------------------------------------------------------------------

const filterWorkersByManager = async (e, formProps) => {
    const managerId = e.value
    localManagerIdToFilterOrgunit.value = managerId

    await getFromRoute('orgunit-filter-by-manager', { manager_id: managerId }, 'get')
    formProps.getLazyData({ page: 1 })
}

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
